module.exports = __webpack_public_path__ + "static/img/qudi (6).2a09fd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (6).jpg
// module id = U5fL
// module chunks = 0